module.exports = __webpack_public_path__ + "img/MARTELO 1,5KG TIPO PENA -desk.fd6bbbbe.png";